/**
 * Modal of the available accent colors.
 */
export enum Accent {
	Mint = 'mint',
	Lavender = 'lavender',
	Pyro = 'pyro',
	Sea = 'sea',
	Love = 'love',
	Rose = 'rose',
}

